class BundleBuilder extends HTMLElement {
  constructor() {
    super();

    this.data = JSON.parse(this.querySelector('#BundleData').textContent);
    this.currentKit = this.data?.kits[0]?.id;

    this.summaries = this.querySelectorAll('.bundle-summary');
    this.toggles = this.querySelectorAll('.bundle-summary__header');
    this.tabs = this.querySelectorAll('.bundle__tab');
    this.buttons = this.querySelectorAll('.bundle__product-action');
    this.progressButtons = this.querySelectorAll(
      '.bundle-summary__progress-action'
    );
    this.filterForms = this.querySelectorAll('.bundle__filter-form');

    this.filterContainers = this.querySelectorAll(
      '.bundle__filter-container, .bundle__filter-details'
    );

    if (window.innerWidth > 749) {
      this.filterContainers.forEach((container) => {
        container.setAttribute('open', true);
      });
    }

    if (this.filterForms) {
      this.filterForms.forEach((form) => {
        form.addEventListener(
          'change',
          this.handleFilterChange.bind(this, form)
        );
      });
    }

    if (this.tabs) {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.selectTab.bind(this, tab));
      });
    }

    if (this.buttons) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.addProduct.bind(this, button));
      });
    }

    if (this.progressButtons) {
      this.progressButtons.forEach((button) => {
        button.addEventListener(
          'click',
          this.handleProgressButtonClick.bind(this, button)
        );
      });
    }

    if (this.toggles) {
      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', this.toggleSummary.bind(this));
      });
    }

    this.update();
  }

  handleFilterChange(form) {
    this.data.applied_filters = {};

    const checkedInputs = form.querySelectorAll(
      'input[type="checkbox"]:checked'
    );

    const filterGroups = {};
    checkedInputs.forEach((input) => {
      const filterType = input.name.split('-').slice(0, -1).join('-');
      const filterValue = input.value;

      if (!filterGroups[filterType]) {
        filterGroups[filterType] = [];
      }
      filterGroups[filterType].push(filterValue);
    });

    Object.keys(filterGroups).forEach((filterType) => {
      if (filterGroups[filterType].length > 0) {
        this.data.applied_filters[filterType] = filterGroups[filterType];
      } else {
        delete this.data.applied_filters[filterType];
      }
    });

    this.update();
  }

  update() {
    const collection = this.querySelector(
      `#BundleCollection-${this.currentKit}`
    );

    if (collection) {
      const products = collection.querySelectorAll('.bundle__product');

      products.forEach((product) => {
        var shouldHide = false;

        // loop through this.data.applied_filters and check if the product matches the filter
        Object.keys(this.data.applied_filters).forEach((filter) => {
          if (filter === 'product-type') {
            if (
              !this.data.applied_filters[filter].includes(product.dataset.type)
            ) {
              shouldHide = true;
            }
          } else if (filter === 'variant-option') {
            const options = product.dataset.options.split(',');

            if (
              !options.some((option) => {
                var includes = false;

                this.data.applied_filters[filter].forEach((filter) => {
                  if (option.includes(filter)) {
                    includes = true;
                  }
                });

                return includes;
              })
            ) {
              shouldHide = true;
            }
          } else {
            if (product.getAttribute(`data-${filter}`)) {
              const dataFilter = product
                .getAttribute(`data-${filter}`)
                .split(',');

              if (
                !dataFilter.some((value) =>
                  this.data.applied_filters[filter].includes(value)
                )
              ) {
                shouldHide = true;
              }
            }
            else {
              shouldHide = true;
            }
          }
        });

        if (shouldHide) {
          product.classList.add('hidden');
        } else {
          product.classList.remove('hidden');
        }
      });

      var showNoProductsFound = true;
      products.forEach((product) => {
        if (!product.classList.contains('hidden')) {
          showNoProductsFound = false;
        }
      });

      if (showNoProductsFound) {
        this.querySelector('.bundle__collection-empty').classList.remove(
          'hidden'
        );
      } else {
        this.querySelector('.bundle__collection-empty').classList.add('hidden');
      }
    }

    if (this.progressButtons) {
      this.progressButtons.forEach((button) => {
        button.disabled = true;
      });
    }

    const productContainer = this.querySelector(
      `#BundleSummary-${this.currentKit}`
    );

    productContainer.innerHTML = '';

    this.data.product_list.forEach((product) => {
      const li = document.createElement('li');
      li.classList.add('bundle-summary__product');
      li.innerHTML = `
        <div class='bundle-summary__product-image'>
          <div class="media media--radius media--square">
            <img src="${product.image}" alt="${product.title}">
          </div>
        </div>

        <div class='bundle-summary__product-info'>
          <div class="bundle-summary__product-title body body--small-desktop body--xsmall-mobile bold">
            ${product.title} x ${product.quantity}
          </div>
          <button 
            data-variant-id="${product.id}"
            data-block-id="${this.currentKit}"
            class="link link--underline body body--xsmall bundle-summary__product-action">
            Remove
          </button>
        </div>
      `;

      productContainer.appendChild(li);

      const removeButton = li.querySelector('.bundle-summary__product-action');

      removeButton.addEventListener(
        'click',
        this.removeProduct.bind(this, removeButton)
      );
    });

    const kitData = this.data.kits.find((kit) => kit.id === this.currentKit);

    const progressBar = this.querySelector(
      `#BundleSummaryProgressBar-${this.currentKit} span`
    );
    const currentProductListLength = Math.min(
      this.data.product_list.reduce(
        (acc, product) => acc + product.quantity,
        0
      ),
      kitData.size
    );
    progressBar.style.width = `${
      (currentProductListLength / kitData.size) * 100
    }%`;

    const progressContent = this.querySelector(
      `#BundleSummaryProgressContent-${this.currentKit}`
    );

    const progressButton = this.querySelector(
      `#BundleSummaryButton-${this.currentKit}`
    );
    if (currentProductListLength >= kitData.size) {
      progressButton.disabled = false;

      progressContent.innerHTML = kitData.progress_complete;
    } else {
      progressButton.disabled = true;

      progressContent.innerHTML = kitData.progress_incomplete
        .replace('|number|', kitData.size - currentProductListLength)
        .replace('|type|', kitData.type);
    }
  }

  toggleSummary(event) {
    event.preventDefault();
    this.summaries.forEach((summary) => {
      summary.classList.toggle('active');
    });
  }

  removeProduct(button) {
    button.closest('.bundle-summary__product').remove();

    this.data.product_list = this.data.product_list.filter(
      (product) => product.id !== button.dataset.variantId
    );
    this.querySelector(
      `.bundle__product-action[data-block-id='${button.dataset.blockId}'][data-variant-id='${button.dataset.variantId}']`
    ).disabled = false;

    this.update();
  }

  addProduct(button) {
    if (
      this.data.product_list.some(
        (product) => product.id === button.dataset.variantId
      )
    ) {
      this.data.product_list.find(
        (product) => product.id === button.dataset.variantId
      ).quantity++;
    } else {
      this.data.product_list.push({
        id: button.dataset.variantId,
        image: button.dataset.variantImage,
        title: button.dataset.variantTitle,
        quantity: 1,
      });
    }

    //button.disabled = true;

    this.update();
  }

  handleProgressButtonClick(button) {
    button.disabled = true;

    const container = button.closest('.bundle-summary');
    const errorContainer = container.querySelector('.bundle-summary__error');

    errorContainer.classList.add('hidden');

    const formData = {
      items: [],
    };

    this.data.product_list.forEach((product) => {
      formData.items.push({
        id: product.id,
        quantity: product.quantity,
        properties: {
          _kit: this.currentKit,
        },
      });
    });

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'bundle-builder',
          cartData: response,
        });

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.open();
        }
      })
      .catch((e) => {
        console.error(e);

        errorContainer.classList.remove('hidden');
        errorContainer.innerHTML = e.message;
      })
      .finally(() => {
        button.disabled = false;
      });
  }

  selectTab(tab) {
    this.data.applied_filters = [];
    this.data.product_list = [];
    this.currentKit = tab.dataset.kitId;

    this.buttons.forEach((button) => {
      button.disabled = false;
    });

    this.update();
  }
}

customElements.define('bundle-builder', BundleBuilder);
